
export type GetAllUsersParams = {
/**
 * 페이지 번호 (0부터 시작)
 */
page?: number;
/**
 * 페이지 크기
 */
size?: number;
/**
 * 정렬 기준 (예: createdAt,desc)
 */
sort?: string;
};
